import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  verificationCode: {
    error: '',
    isLoading: false,
    showModalOtp: false,
    success: false,
    verificationToken: null,
    verified: false,
  },
};

export default handleActions({
  SEND_VERIFICATION_CODE_FAILED: (state, { payload }) => ({
    ...state,
    verificationCode: {
      ...state.verificationCode,
      error: payload,
      isLoading: false,
      showModalOtp: true,
      success: false,
      verified: false,
    },
  }),

  SEND_VERIFICATION_CODE_SUCCESS: (state) => ({
    ...state,
    verificationCode: {
      ...state.verificationCode,
      error: '',
      isLoading: false,
      showModalOtp: true,
      success: true,
    },
  }),

  VERIFY_CODE_ATTEMPT: (state) => ({
    ...state,
    verificationCode: {
      ...state.verificationCode,
      error: '',
      isLoading: true,
      showModalOtp: true,
      success: false,
      verificationToken: null,
      verified: false,
    },
  }),

  VERIFY_CODE_FAILED: (state, { payload }) => ({
    ...state,
    verificationCode: {
      ...state.verificationCode,
      error: payload,
      isLoading: false,
      verificationToken: null,
      verified: false,
    },
  }),

  VERIFY_CODE_RESET: (state) => ({
    ...state,
    verificationCode: {
      ...state.verificationCode,
      error: '',
      isLoading: false,
      showModalOtp: false,
      success: false,
      verificationToken: null,
      verified: false,
    },
  }),

  VERIFY_CODE_SUCCESS: (state, { payload }) => ({
    ...state,
    verificationCode: {
      ...state.verificationCode,
      error: '',
      showModalOtp: false,
      verificationToken: payload,
      verified: true,
    },
  }),
}, INITIAL_STATE);
